<template>
  <header
    id="mainNav"
    :style="!checkRoute ? 'background-color: var(--primary)' : ''"
    class="navbar navbar-expand-lg navbar-light fixed-top py-2"
  >
    <div class="container">
      <router-link
        :to="{name: default_page}"
        class="navbar-brand color-primary font-primary"
      >
        <img
          alt="logo.png"
          class="icon-image"
          src="/img/logo.png"
        >
      </router-link>
      <button
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler navbar-toggler-right"
        data-target="#navbarResponsive"
        data-toggle="collapse"
        type="button"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <nav class="navbar-nav nav-center d-none d-lg-block">
        <ul class=" navbar-nav border-0">
          <li
            class="nav-item black borrow-invest-item borrow-item btn-borrow-invest"
            @mouseenter="onMouseEnter($event, 'borrow', true)"
            @mouseleave="onMouseEnter($event, 'borrow', false)"
          >
            <a
              :class="`nav-link nav-tab-title ${borrowInvestModel === 'borrow' ? 'has-arrow has-arrow-borrow' : ''}`"
              data-toggler="true"
              href="javascript:void(0)"
              @click="onClickBorrowInvest('borrow')"
            >
              {{ $t('label.borrow').toUpperCase() }}
            </a>
            <div
              :class="borrowInvestModel === 'borrow' ? 'active' : ''"
              class="sub-nav-content-borrow sub-navbar-content"
            >
              <div class="sub-nav-panel">
                <nav role="navigation">
                  <div>
                    <ul class="nav navbar-nav">
                      <li class="sub-nav-item2 sub-nav-item">
                        <router-link
                          :to="{name: 'home'}"
                          class="sub-nav-penal-item has-border-r"
                          @click.native="onNavBarDropDown"
                        >
                          <span class="sub-nav-panel-title bold">{{ $t('label.payDayLoan') }}</span>
                          <i class="fa fa-chevron-right nav-chevron-right" />
                          <span class="sub-nav-panel-desc">{{ $t('borrow.string.shortTerm') }}</span>
                        </router-link>
                      </li>

                      <li class="sub-nav-item2 sub-nav-item">
                        <router-link
                          :to="{name: 'personal_loans'}"
                          class="sub-nav-penal-item"
                          @click.native="onNavBarDropDown"
                        >
                          <span class="sub-nav-panel-title bold">{{ $t('label.personalLoan') }}</span>
                          <i class="fa fa-chevron-right nav-chevron-right" />
                          <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
                        </router-link>
                      </li>
                      <li class="sub-nav-item2 sub-nav-item">
                        <router-link
                          :to="{name: 'purchasing_service'}"
                          class="sub-nav-penal-item has-border-r"
                          @click.native="onNavBarDropDown"
                        >
                          <span class="sub-nav-panel-title bold">{{ $t('label.purchasing') }}</span>
                          <i class="fa fa-chevron-right nav-chevron-right" />
                          <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
                        </router-link>
                      </li>
                      <li class="sub-nav-item2 sub-nav-item">
                        <router-link
                          :to="{name: 'pawn_service'}"
                          class="sub-nav-penal-item"
                          @click.native="onNavBarDropDown"
                        >
                          <span class="sub-nav-panel-title bold">{{ $t('label.pawn') }}</span>
                          <i class="fa fa-chevron-right nav-chevron-right" />
                          <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </li>
          <span style="color: #3c56a000">|</span>
        </ul>
      </nav>
      <!--use for mobile screen-->
      <div
        id="navbarResponsive"
        class="collapse navbar-collapse float-right"
      >
        <ul class="navbar-nav ml-auto my-2 my-lg-0">
          <li :class="`${navItemClass} ${$route.name === 'home' || $route.name === 'personal_loans' ? 'active' : ''}`">
            <router-link
              :style="navLinkPadding"
              :to="{name: 'personal_loans'}"
              class="nav-link"
              @click.native="closeNavBar"
            >
              <i class="fa fa-home" />
            </router-link>
          </li>
          <li
            :class="`${navItemClass} dropdown`"
            class="show-dropdown"
          >
            <a
              id="navbarDropdownBorrow"
              aria-expanded="false"
              aria-haspopup="true"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              href="javascript:void(0)"
              role="button"
            >
              {{ $t('label.borrow').toUpperCase() }}
            </a>
            <div
              aria-labelledby="navbarDropdown"
              class="dropdown-menu"
            >
              <router-link
                :to="{name: 'home'}"
                class="dropdown-item must-wrap pb-2 pt-1 border-bottom"
                @click.native="closeNavBar"
              >
                <span class="sub-nav-panel-title bold">{{ $t('label.payDayLoan') }}</span> <i
                  class="fa fa-chevron-right nav-chevron-right"
                />
                <span class="sub-nav-panel-desc">{{ $t('borrow.string.shortTerm') }}</span>
              </router-link>
              <router-link
                :to="{name: 'personal_loans'}"
                class="dropdown-item must-wrap pb-1 pt-2 border-bottom"
                @click.native="closeNavBar"
              >
                <span class="sub-nav-panel-title bold">{{ $t('label.personal_loan') }}</span> <i
                  class="fa fa-chevron-right nav-chevron-right"
                />
                <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
              </router-link>
              <router-link
                :to="{name: 'pawn_service'}"
                class="dropdown-item must-wrap pb-1 pt-2 border-bottom"
                @click.native="closeNavBar"
              >
                <span class="sub-nav-panel-title bold">{{ $t('label.pawn') }}</span> <i
                  class="fa fa-chevron-right nav-chevron-right"
                />
                <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm') }}</span>
              </router-link>
              <router-link
                :to="{name: 'purchasing_service'}"
                class="dropdown-item must-wrap pb-1 pt-2"
                @click.native="closeNavBar"
              >
                <span class="sub-nav-panel-title bold">{{ $t('label.purchasing') }}</span> <i
                  class="fa fa-chevron-right nav-chevron-right"
                />
                <span class="sub-nav-panel-desc">{{ $t('borrow.string.longTerm_1_12') }}</span>
              </router-link>
            </div>
          </li>
          <li :class="`${navItemClass} ${$route.name === 'faq' ? 'active' : ''}`">
            <router-link
              :style="navLinkPadding"
              :to="{name: 'faq'}"
              class="nav-link"
              @click.native="closeNavBar"
            >
              {{ $t("menubar.faq") }}
            </router-link>
          </li>
          <li :class="`${navItemClass} ${$route.name === 'contact' ? 'active' : ''}`">
            <router-link
              :style="navLinkPadding"
              :to="{name: 'contact'}"
              class="nav-link"
              @click.native="closeNavBar"
            >
              {{ $t("menubar.contact") }}
            </router-link>
          </li>
          <li :class="`${navItemClass} ${$route.name === 'referral' ? 'active' : ''}`">
            <router-link
              :style="navLinkPadding"
              :to="{name: 'referral'}"
              class="nav-link"
              @click.native="closeNavBar"
            >
              {{ $t("menubar.referral") }}
            </router-link>
          </li>
          <li :class="`${navItemClass} ${$route.name === 'about' ? 'active' : ''}`">
            <router-link
              :style="navLinkPadding"
              :to="{name: 'about'}"
              class="nav-link"
              @click.native="closeNavBar"
            >
              {{ $t("menubar.about") }}
            </router-link>
          </li>
          <!--          +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
          <template v-if="isLogged === false">
            <li :class="`${navItemClass} ${$route.name === 'login' ? 'active' : ''}`">
              <router-link
                :style="navLinkPadding"
                :to="{name: 'login'}"
                class="nav-link"
                @click.native="closeNavBar"
              >
                {{ $t("button.login") }}
              </router-link>
            </li>
          </template>
          <template v-if="isLogged">
            <li
              :class="`${navItemClass} dropdown`"
              style="padding-left: 0.5rem"
            >
              <a
                id="navbarDropdown1"
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle dropdown-toggle-avatar"
                data-toggle="dropdown"
                href="javascript:void(0)"
                role="button"
              >
                <template v-if="avatar">
                  <template v-if="avatar.includes('https://graph.facebook.com')">
                    <div
                      :style="`background-image: url(${avatar})`"
                      class="service-avatar"
                    />
                  </template>
                  <template v-else>
                    <div
                      :style="`background-image: url(${$base_api}/${avatar})`"
                      class="service-avatar"
                    />
                  </template>
                </template>
                <template v-else>
                  <div class="service-avatar" />
                </template>
              </a>
              <div
                aria-labelledby="navbarDropdown"
                class="dropdown-menu dropdown-menu-right dropdown-menu-width dropdown-avatar"
              >
                <ul
                  style="padding-left: 0"
                  type="none"
                >
                  <li>
                    <router-link
                      :to="{name: 'profile', params: {activeTabs: 'profile'}}"
                      class="dropdown-item"
                    >
                      <i class="fa fa-user" /> {{ $t('label.profile') }}
                    </router-link>
                  </li>
                  <li class="divider" />
                  <li>
                    <button
                      class="dropdown-item"
                      @click="logout"
                    >
                      <i class="fas fa-sign-out-alt" /> {{ $t('label.logout') }}
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          </template>
          <!--          +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
          <li :class="`${navItemClass} dropdown`">
            <a
              :style="navLinkPadding"
              class="nav-link"
              href="javascript:void(0)"
              @click="onChangeLocale"
            >
              <template v-if="locale === 'en'">
                <img
                  class="icon-language"
                  src="/img/kh_icon.png"
                >
              </template>
              <template v-else>
                <img
                  class="icon-language"
                  src="/img/en_icon.png"
                >
              </template>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CashHeroNavbar',
  props: {
    bright: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    borrowInvestModel: function () {
      if (this.borrowInvestModel !== 'none') {
        this.allowClickToClose = false
        const self = this
        setTimeout(function () {
          self.allowClickToClose = true
        }, 500)
      }
    },
    '$store.state.logged_in': function () {
      this.isLogged = this.$store.state.logged_in
    }
  },
  data () {
    return {
      isLogged: this.checkIfIsLogged(),
      locale: this.$i18n.locale,
      borrowInvestModel: 'none', // 'borrow', 'invest', 'none'
      borrowInvestModelHandler: null,
      brand: process.env.VUE_APP_NAME,
      default_page: this.$default_page,
      allowClickToClose: true,
      token: localStorage.getItem('token'),
      avatar_img: '',
      list_routes: [
        'home',
        // 'login',
        'personal_loans',
        'purchasing_service',
        'pawn_service'
      ]
    }
  },
  computed: {
    checkRoute () {
      return !!this.list_routes.includes(this.$route.name)
    },
    avatar () {
      return this.$store.state.borrow.borrower_photo
    },
    navItemClass () {
      if (this.bright) {
        return 'nav-item black'
      }
      return 'nav-item'
    },
    navLinkPadding () {
      if (this.$i18n.locale === 'km') {
        return 'padding: 0 0.5rem;'
      } else {
        return 'padding: 0 1rem;'
      }
    }

  },
  methods: {
    checkIfIsLogged () {
      const token = localStorage.getItem('token')
      if (token) {
        return true
      } else {
        return false
      }
    },
    logout () {
      this.$isLoading(true)
      this.$axios.post(this.$base_api + '/api/auth/logout').finally(() => {
        this.$store.dispatch('boardInformation/toggleShowValue', false)
        this.$store.dispatch('resetStateBorrower')
        this.$store.dispatch('checkUserHasPendingLoan', false)
        this.$store.dispatch('checkUserLogin', false)
        this.$axios.defaults.headers.common.Authorization = null
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        this.isLogged = this.checkIfIsLogged()
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push({ name: this.$default_page })
        this.$isLoading(false)
      })
    },
    onChangeLocale () {
      if (this.locale === 'en') {
        this.locale = 'km'
      } else {
        this.locale = 'en'
      }
      if (this.locale === 'km') {
        this.$i18n.locale = 'km'
        this.locale = 'km'
      } else {
        this.$i18n.locale = 'en'
        this.locale = 'en'
      }
      this.closeNavBar()
      localStorage.setItem('locale', this.$i18n.locale)
      this.$axios.defaults.headers.common['X-localization'] = this.$i18n.locale
    },
    onMouseEnter (event, value, enter) {
      clearTimeout(this.borrowInvestModelHandler)
      if (enter) {
        this.borrowInvestModelHandler = setTimeout(() => {
          this.borrowInvestModel = value
        }, 300)
      }
    },
    onClickBorrowInvest (item) {
      if (this.borrowInvestModel === item) {
        if (this.allowClickToClose) {
          this.borrowInvestModel = 'none'
        }
      } else {
        this.borrowInvestModel = item
      }
    },
    onNavBarDropDown () {
      this.borrowInvestModel = 'none'
      $(document).scrollTop(0)
    },
    closeNavBar () {
      if ($) {
        $('.navbar-collapse').collapse('hide')
      }
    },
    detectMouseClick: function (e) {
      if ($(e.target).data('toggler')) {
        return
      }
      if (this.borrowInvestModel !== 'none' && e.target.closest('.sub-navbar-content') === null) {
        this.borrowInvestModel = 'none'
      }
    }
  },
  mounted () {
    $(document).on('click', this.detectMouseClick)
  },
  destroyed () {
    $(document).off('click', this.detectMouseClick)
  }
}
</script>

<style scoped>
a {
  color: var(--primary) !important;
  display: block;
}

a:hover {
  text-decoration: none !important;
}

.dropdown-item {
  cursor: pointer;
  color: black !important;
}

.nav-link {
  font-weight: normal !important;
  font-size: 1em !important;
}

.nav-item {
  padding-bottom: 5px;
}

.active {
  font-weight: bold;
}

.dropdown-item.active, .dropdown-item:active {
  background-color: var(--primary);
  color: white;
}

.active > a,
.black > a,
.dropdown-item.active
.dropdown-item.active:hover,
.dropdown-item:active {
  color: white !important;
}

#mainNav.navbar-scrolled {
  background-color: var(--primary);
}

#mainNav.navbar-scrolled .navbar-nav .nav-item .nav-link:hover,
#mainNav .navbar-nav .nav-item .nav-link:hover {
  /*color: var(--very-light-blue) !important; Open after 5 day*/
  color: var(--dark-blue) !important;
}

.navbar-toggler {
  background-color: white !important;
}

.sub-nav-content-borrow {
  width: 540px;
  left: calc(50% - 272px);
}

.sub-nav-content-invest {
  width: 295px;
  left: calc(50% - 145px);
}

.sub-navbar-content {
  position: absolute;
  background: white;
  padding: 15px;
  display: none;
  top: 48px;
  margin: 0;
  border: 1px solid #e2e5e5;
  /*border-radius: 20px;*/
  border-radius: var(--border-raduis) !important;
  box-shadow: 1px 8px 35px #00000044;
  height: auto;
  z-index: 104;
}

.sub-nav-panel {
  position: relative;
  font-size: 1rem;
  color: white;
}

.sub-nav-item2 {
  width: 50%;
}

.sub-nav-item1 {
  width: 100%;
}

.sub-nav-item {
  padding: 10px 0 10px 20px;
}

.sub-nav-item::after:last-child {
  border: none;
}

.sub-nav-penal-item {
  padding-right: 10px;
}

.has-border-r {
  border-right: 1px solid #cac7c7;
}

.sub-nav-panel-title {
  font-size: 1.0625rem;
}

.nav-chevron-right {
  margin: 0 5px;
  font-size: 13px;
}

.sub-nav-item:hover {
  cursor: pointer;
}

.sub-nav-item:hover .sub-nav-panel-title,
.sub-nav-item:hover .nav-chevron-right {
  color: var(--secondary) !important;
}

.sub-nav-panel-desc {
  display: block;
  padding-top: 10px;
  font-weight: lighter;
}

.bold {
  font-weight: 400;
}

.has-arrow-borrow::before {
  left: calc(50% - 20px);
}

.has-arrow-invest::before {
  left: calc(50% - 10px);
}

.has-arrow::before {
  content: "";
  position: absolute;
  bottom: -20px;
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
  border-bottom: 15px solid white;
  z-index: 105;
}

.icon-image {
  height: 45px;
  margin: 0 0 10px;
}

.icon-language {
  width: 24px;
}

@media screen and (max-width: 991px) {
  #mainNav {
    max-height: 100vh;
    background-color: var(--primary);
  }

  #mainNav .navbar-nav .nav-item .nav-link {
    padding: 0.4rem 0 !important;
  }
}

@media screen and (max-width: 767px) {
  .icon-image {
    height: 35px;
    margin: 5px 0;
  }
}

.nav-center {
  left: calc(45% - 195px);
  position: absolute;
  display: block;
  clear: both;
}

.borrow-invest-item {
  position: relative;
}

.borrow-invest-item > div.active {
  display: block;
  border-bottom: 0;
}

.borrow-item::after {
  /*content: "";*/
  position: absolute;
  top: -10px;
  left: -10px;
  background-color: transparent;
  height: 30px;
  width: 30px;
  border-top: 3px solid var(--secondary);
  border-left: 3px solid var(--secondary);
  transition: 300ms;
}

.borrow-item:hover::after {
  border-top-left-radius: 20px;
}

.invest-item::after {
  /*content: "";*/
  position: absolute;
  bottom: -5px;
  right: -10px;
  background-color: transparent;
  height: 30px;
  width: 30px;
  border-right: 3px solid var(--secondary);
  border-bottom: 3px solid var(--secondary);
  transition: 300ms;
}

.invest-item:hover::after {
  border-bottom-right-radius: 20px;
}

@media screen and (min-width: 992px) {

  .show-dropdown {
    display: none;
  }

  .active {
    font-weight: normal;
    border-bottom: 2px solid white;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown) > a {
    height: 100%;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active) {
    position: relative;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active):after {
    content: '';
    background-color: var(--dark-blue) !important;
    position: absolute;
    transition: 300ms;
    height: 2px;
    bottom: 0px;
    width: 0;
  }

  #navbarResponsive > ul > li.nav-item:not(.dropdown):not(.active):hover:after {
    width: 100%;
  }
}

.btn-borrow-invest {
  padding: 10px;
  border-radius: var(--border-raduis) !important;
  border: 2px solid white;
}

.btn-borrow-invest a.has-arrow-borrow {
  color: white;
}

.primary-text {
  color: var(--dark-blue) !important;
}

/*==========================================================================================*/
.service-avatar {
  background-image: url("../../public/img/woman-call.png");
  border-radius: 50%;
  background-position: top;
  background-size: cover;
  height: 23px;
  width: 23px;
  display: inline-block;
}

.dropdown-toggle-avatar:after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.6em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-avatar > ul > li > .dropdown-item:hover {
  color: white !important;
  background-color: var(--primary);
}

.divider {
  height: 1px;
  margin: 4px 0;
  padding: 0;
  background-color: #dfdfdf;
}

.dropdown-menu-width {
  min-width: 240px;
  max-width: 500px;
  z-index: 10000
}
</style>
